module.exports = __webpack_public_path__ + "static/media/guide-dive.3eaac628.png";